module.exports = __webpack_public_path__ + "img/ZIP.e3b388f6.png";